import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import Spinner from '~/icons/spinner.svg';
import { Container } from '~/shared/components/Container';
import { breakpoints } from '~/theme/breakpoints';
import { Button } from '~/shared/components/Button';
import { mq } from '~/lib';

const ROTATING_ANIMATION = keyframes({
    to: { transform: 'rotate(360deg);' },
});

export const LoaderSpinner = styled(Spinner)(() => ({
    width: '15px',
    height: '15px',
    animation: `${ROTATING_ANIMATION} 1.5s infinite`,
    position: 'absolute',
    zIndex: 1,
}));

export const StyledStoresInStockLink = styled(Button)(({ theme }) => ({
    minHeight: 'initial',
    width: 'auto',

    [mq('md')]: {
        paddingTop: theme.space[2],
        paddingBottom: theme.space[2],
    },

    [mq(0, 'sm')]: {
        fontSize: theme.fontSizes.xs,
    },
}));

export const ContentContainer = styled(Container)(({ theme }) => ({
    padding: 0,
    maxWidth: 1264,
    [breakpoints.sm]: {
        padding: `0 ${theme.space[3]}`,
    },
    [breakpoints.md]: {
        padding: `0 ${theme.space[5]}`,
    },
}));
